export default __webpack_public_path__ + "static/media/icon-nav-cabin-issues.5bf1036d.svg";